import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function ReferralHandler() {
  const { referralCode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (referralCode) {
      localStorage.setItem("referral_code", referralCode);
    }
    navigate("/sign-up", { replace: true });
  }, [referralCode, navigate]);

  return null;
}
